import { blushColors } from './cheekEyeshadowColors';

const blushConfig = {
  id: 'blush',
  label: 'Blush',
  icon: 'blush',
  colors: blushColors,
  finishTypes: [
    { id: 'satin', name: 'Satin' },
    { id: 'matte', name: 'Matte' },
    { id: 'sheer', name: 'Sheer' },
    { id: 'shimmer', name: 'Shimmer' },
    { id: 'glossy', name: 'Glossy' },
  ],
  intensityDefault: 75,
  intensityMin: 0,
  intensityMax: 100,
  spreadDefault: 85,
  spreadMin: 1,
  spreadMax: 100,
  smoothRadiusDefault: 75,
  smoothRadiusMin: 1,
  smoothRadiusMax: 150,
};

export default blushConfig;
